import {
  PostApiReportDeleteReportParams,
} from 'dtos';
import {
  FileResultDTO,
} from 'dtos/fileResultDTO';
import {
  ReportRequestDTOBase,
} from 'dtos/reportRequestDTOBase';
import {
  ReportSettingsResponseDTO,
} from 'dtos/reportSettingsResponseDTO';
import {
  TriggerReportResponseDTO,
} from 'dtos/triggerReportResponseDTO';
import {
  getApiReportGetReportSettings,
  postApiReportDeleteReport,
} from 'endpoints';
import {
  useMutation,
  UseMutationResult,
  useQuery,
  UseQueryResult,
} from '@tanstack/react-query';
import {
  sendRequest,
} from 'utils/httpClient';

export function useGetReportMetadata(): UseQueryResult<ReportSettingsResponseDTO, Error> {
  return useQuery<ReportSettingsResponseDTO, Error>({
    queryKey: ['report-settings'],
    queryFn: getApiReportGetReportSettings,
  });
}

export function useTriggerReport(): UseMutationResult<
  TriggerReportResponseDTO,
  Error,
  ReportRequestDTOBase & { endpointName?: string | null }
  > {
  return useMutation<
    TriggerReportResponseDTO,
    Error,
    ReportRequestDTOBase & { endpointName?: string | null }
  >({
    mutationFn: (data) => {
      const effectiveEndpoint = (data?.endpointName ?? '').toString();
      return sendRequest<TriggerReportResponseDTO>({
        url: `/api/Report/${effectiveEndpoint}`,
        method: 'post',
        data,
      });
    },
  });
}

export function useDeleteReport(): UseMutationResult<
FileResultDTO, Error, PostApiReportDeleteReportParams> {
  return useMutation<FileResultDTO, Error, PostApiReportDeleteReportParams>({
    mutationFn: (params) => postApiReportDeleteReport(params),
  });
}
